import { Splide, SplideSlide } from "@splidejs/react-splide";
import React, { Fragment } from "react";
import { MdOutlineVerifiedUser } from "react-icons/md";
import SingleSlider from "../../Components/Sliders/SingleSlider";
import "@splidejs/splide/css";
import ProductCard from "../../Components/Cards/Product";
import { useContactData, useSingle } from "./Hooks";
import Loading from "../../Components/Loading";
import { renderPrice } from "../../Utils/functions";
import CustomSlider from "../../Components/Sliders/CustomSlider";
import { Modal, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { BiChevronLeft } from "react-icons/bi";
import { BsBookmark, BsBookmarkCheck } from "react-icons/bs";
import { Helmet } from "react-helmet";
import { IoAlertOutline } from "react-icons/io5";
import Plans from "../Plans";
import { HiOutlineLogin } from "react-icons/hi";
import { useMainLayout } from "../../Layouts/Hooks";

// import "./styles.css";

const Single = () => {
  const {
    data,
    loading,
    handler,
    toggle,
    markLoading,
    form,
    setForm,
    contactLoading,
    getContactData,
  } = useSingle();

  const { isLogin } = useMainLayout();

  if (loading) {
    return (
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="single-product">
              <Loading height={"783px"} />
            </div>
          </div>
        </div>
      </div>
    );
  }
  let check = () => {
    let res = false;
    data?.ads?.options?.map(op => {
      if (op.id == 1) {
        res = true;
      }
    });
    return res;
  };
  return (
    <Fragment>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>

      {
        !data.need_expence
          ?
          <div className="container" id="single-page">
            <div className="row justify-content-center">
              <div className="col-lg-10 ">
                <div className="single-product">
                  <div className="title-single">
                    <h1>{data?.ads?.title}</h1>
                  </div>
                  <div className="single-product-content">
                    <div className="row">
                      <div className="col-lg-5 pt-2">
                        <div className="value-label">
                          <h4>نام آگهی دهنده:</h4>
                          <span>{data?.ads?.contacts_data?.fullname || data?.ads?.contacts_data?.co_name || data?.ads?.client?.fullname}</span>
                        </div>
                        <div className="value-label">
                          <h4>شهر : </h4>
                          <span>{data?.ads?.city?.title || "ثبت نشده"}</span>
                        </div>
                        <div className="value-label">
                          <h4>دسته بندی : </h4>
                          <span>{data?.ads?.category?.title}</span>
                        </div>
                        <div className="value-label">
                          <h4>قیمت : </h4>
                          <span>{renderPrice(data?.ads?.price)}</span>
                        </div>
                        <div className="contact-section">
                          <p>لحظاتی پیش</p>
                          <div>
                            <button
                              style={{
                                backgroundColor: "transparent",
                                padding: "10px",
                              }}
                              onClick={toggle}
                              disabled={markLoading}
                            >
                              {markLoading ? (
                                <Spinner size="sm" />
                              ) : data.mark == "false" ? (
                                <>
                                  {
                                    <BsBookmark className="BsBookmark"
                                      size={"1.4rem"}
                                    />
                                  }
                                </>
                              ) : (
                                <>
                                  {
                                    <BsBookmarkCheck
                                      size={"1.4rem"}
                                      color="rgb(0 153 255)"
                                    />
                                  }
                                </>
                              )}
                            </button>
                            <button onClick={handler}>اطلاعات تماس</button>
                          </div>
                        </div>

                        {check() && (
                          <div>
                            <div className="accept">
                              <MdOutlineVerifiedUser className="primary-color" />
                              <p className="">آگهی های تایید شده توسط صنعتبان</p>
                            </div>
                            <p>آگهی موردنظر توسط صنعتبان تایید شده است</p>
                          </div>
                        )}

                      </div>
                      <div className="col-lg-7">
                        <SingleSlider data={data?.ads} />
                      </div>
                    </div>
                    <div className="row justify-content-center content-single mb-3">
                      <div className="col-12">
                        <h4>
                          توضیحات
                        </h4>
                      </div>
                      <div className=" mt-3">
                        <p>{data?.ads?.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {data?.likeitem.length > 0 && (
              <>
                <div className="row justify-content-center mt-5" style={{}}>
                  <div className="col-lg-10">
                    <div className="similarAdBox">

                      <h2 className="similarTitle mb-4">آگهی های مشابه</h2>

                      <CustomSlider
                        data={data?.likeitem}
                        renderCard={(data, count) => {
                          return <div className="similarAdtem"><ProductCard data={data} key={count} /></div>;
                        }}
                        isReserve={true}
                        numbers={4}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
            <Modal
              show={form.show}
              centered
              onHide={() => {
                setForm({ ...form, show: false });
              }}
            >
              <ContactDetails check={check} />
            </Modal>
          </div>
          :
          <div className="container">
            <div className="row mx-0 position-relative">
              <h5 className="text-danger alertForPlan sort-card d-flex justify-content-center py-3 border border-danger mb-4">
                <IoAlertOutline size={"25px"} />
                کاربر گرامی جهت نمایش آگهی‌های این دسته بندی لطفا اشتراک تهیه نمائید
              </h5>
              {isLogin()
                ?
                <div className="px-0 planBoxListPage">
                  <Plans />
                </div>
                :
                <Link className="btn btn-outline-primary mx-auto" to={"/login"} style={{ width: "200px" }}>
                  <HiOutlineLogin className="ms-2" size={25} />
                  <span>ورود / ثبت نام</span>
                </Link>
              }

            </div>
          </div>

      }


    </Fragment>
  );
};

export default Single;
const ContactDetails = ({ check }) => {
  const { data, loading } = useContactData();
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-baseline py-5">
        <Spinner />
      </div>
    );
  }
  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          اطلاعات تماس
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {data.contacts_data ? (
          <>
            {
              data.contacts_data.fullname &&
              <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                <p>نام و نام خانوادگی : </p>
                <p>{data?.contacts_data?.fullname}</p>
              </div>
            }
            {
              data.contacts_data.co_name &&
              <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                <p>نام شرکت : </p>
                <p>{data?.contacts_data?.co_name}</p>
              </div>
            }
            {data.contacts_data.co_mobile &&
              <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                <p>شماره تماس : </p>
                <p>{data?.contacts_data?.co_mobile}</p>
              </div>
            }
            {data.contacts_data.mobile &&
              <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                <p>شماره تماس : </p>
                <p>{data?.contacts_data?.mobile}</p>
              </div>
            }
            {data.contacts_data.co_tell &&
              <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                <p>تلفن ثابت  : </p>
                <p>{data?.contacts_data?.co_tell}</p>
              </div>
            }
            {
              data.contacts_data.co_addres &&
              <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                <p>آدرس شرکت : </p>
                <p>{data?.contacts_data?.co_addres}</p>
              </div>
            }
            {
              data.contacts_data.co_url &&
              <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                <p>آدرس سایت : </p>
                <p>{data?.contacts_data?.co_url}</p>
              </div>
            }
            {data.contacts_data.email &&
              <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                <p>ایمیل : </p>
                <p>{data?.contacts_data?.email}</p>
              </div>
            }

            {!check() && (
              <div className="access-error">
                <p>
                  صنعتبان هیچ‌گونه منفعت و مسئولیتی در قبال معامله شما
                  ندارد.
                </p>
              </div>
            )}
          </>
        ) : (
          <>
            <p>برای مشاهده اطلاعات تماس باید پلن مربوط را خریداری کنید</p>
            <div className="d-flex justify-content-end">
              <Link className="btn btn-link btn-sm px-0" to={"/plans"}>
                خرید اشتراک
                <BiChevronLeft />
              </Link>
            </div>
          </>
        )}
      </Modal.Body>
    </>
  );
};
